import $ from "jquery";

const maskPhoneBehavior = function (val) {
  return val.replace(/\D/g, "").length === 11 ? "(00) 00000-0000" : "(00) 0000-00009";
};

const optionsPhoneMask = {
  onKeyPress: function (val, e, field, options) {
    field.mask(maskPhoneBehavior.apply({}, arguments), options);
  },
};

function load_number_masks() {
  $(".cpf").mask("00000000000", { reverse: true });
  $(".cep").mask("00000-000", { reverse: true });
  $(".cep-no-mask").mask("00000000", { reverse: true });
  $(".phone").mask(maskPhoneBehavior, optionsPhoneMask);
}

// Valida valor máximo de um input
$(document).ready(function () {
  $(".number-input-max").on("change paste keyup", function () {
    const maxValue = parseFloat($(this).attr("maxValue"));
    const input_value = parseFloat($(this).val());

    if (maxValue && input_value > maxValue) $(this).val(maxValue);
  });

  // Para facilitar o uso, seleciona todo o texto do input ao clicar
  $(".number-input-max").on("click", function () {
    $(this).select();
  });
});

$(function () {
  load_number_masks();
});
